import React from "react";
import { Box, Grid, Divider, Tooltip } from "@mui/material";
import { TooltipName } from "../../../../utils/Enums";
import archivedBoard from "../../../../styles/svg/Vector-archived.svg";
import privateBoard from "../../../../styles/svg/lock-milestone.svg";
import { useUserProfileSidebar } from "../hooks/useUserProfileSidebar";

function UserProfileSidebar({ profileData, onChangePassword , userId}) {
  const {
    handleAssignedTasksClick,
    handleBoardClick,
    handleWorklogsClick,
    validBoards,
  } = useUserProfileSidebar({ profileData, userId });

  return (
    <>
      <Grid item xs={5} pr={6}>
        <ul style={{ paddingLeft: "14px" }}>
          <li onClick={handleAssignedTasksClick} style={{ width: "fit-content", }}>
            Assigned Tasks
          </li>
          <li onClick={handleWorklogsClick} style={{ width: "fit-content",}}>Worklogs</li>
          <li onClick={onChangePassword} style={{ width: "fit-content" }}>
            Change Password
          </li>
        </ul>

        <p className="head-user-profile">Boards</p>
        <Box
          className="custom-scrollbar"
          sx={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 410px)",
            minHeight: "200px",
            paddingRight: '12px',
          }}
        >
          {validBoards.length > 0  ? (
            <ul style={{ paddingLeft: "14px" }}>
              {validBoards.map((ele, idx) => (
                <li
                  key={idx}
                  onClick={() => handleBoardClick(ele)}
                  className={ele?.is_private ? "disabled-board-link" : ""}
                >
                  <div className="boards-user-profile">
                    <p>{ele.board_name}</p>
                    <div className="board-status-icons">
                      {ele.is_private && (
                        <Tooltip title={TooltipName.MANAGE_USER.PRIVATE_BOARD}>
                          <img src={privateBoard} alt="private board" />
                        </Tooltip>
                      )}
                      {ele.is_archive && (
                        <Tooltip title={TooltipName.MANAGE_USER.ARCHIVED_BOARD}>
                          <img src={archivedBoard} alt="archived board" />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            "No boards assigned yet"
          )}
        </Box>
      </Grid>
      <Divider orientation="vertical" variant="middle" flexItem />
    </>
  );
}

export default React.memo(UserProfileSidebar);
